import { fetchAPI, API_BASE_URL } from "./apiCore";
import { getToken, getuserId } from "./auth";


// Fetch Ordering Physician
export const fetchProviders = async () => {
  try {
    return await fetchAPI("biobank/providers", "GET");
  } catch (error) {
    console.error("Error fetching providers:", error);
    return [];
  }
};

// Fetch Next Provider ID
export const fetchNextProviderId = async () => {
  try {
    const res = await fetchAPI("biobank/providers/next-id", "GET");
    return res.nextId;
  } catch (error) {
    console.error("Error fetching next provider ID:", error);
    return "00001";
  }
};

// Get provider by ID
export const fetchProviderById = async (providerId) => {
  try {
    return await fetchAPI(`biobank/providers/${providerId}`, "GET");
  } catch (error) {
    console.error("Error fetching provider:", error);
    return null;
  }
};


// Create provider
export const createProvider = async (providerData) => {
  try {
    return await fetchAPI("biobank/providers", "POST", {}, providerData);
  } catch (error) {
    console.error("Error creating provider:", error);
    throw error;
  }
};


// Update provider (full replacement - PUT)
export const updateProvider = async (providerId, providerData) => {
  try {
    return await fetchAPI(
      `biobank/providers/${providerId}`,
      "PUT",
      {},
      providerData
    );
  } catch (error) {
    console.error("Error updating provider:", error);
    throw error;
  }
};


// Patch provider (partial update - PATCH)
export const patchProvider = async (providerId, providerData) => {
  try {
    return await fetchAPI(
      `biobank/providers/${providerId}`,
      "PATCH",
      {},
      providerData
    );
  } catch (error) {
    console.error("Error patching provider:", error);
    throw error;
  }
};


// Delete provider
export const deleteProvider = async (providerId) => {
  try {
    return await fetchAPI(`biobank/providers/${providerId}`, "DELETE");
  } catch (error) {
    console.error("Error deleting provider:", error);
    throw error;
  }
};


// Upload providers from CSV file
export const uploadProvidersCSV = async (file) => {
  try {
    const token = await getToken();
    if (!token) {
      throw new Error("Authentication token not available");
    }

    const formData = new FormData();
    formData.append("file", file);

    const response = await fetch(`${API_BASE_URL}/biobank/providers/upload`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        // Don't set Content-Type - browser will set it with boundary for FormData
      },
      body: formData,
    });

    const contentType = response.headers.get("content-type");
    const responseData =
      contentType && contentType.includes("application/json")
        ? await response.json()
        : await response.text();

    if (!response.ok) {
      const errorMessage =
        typeof responseData === "string"
          ? responseData
          : responseData?.message || "Failed to upload CSV file";
      throw new Error(errorMessage);
    }

    return responseData;
  } catch (error) {
    console.error("Error uploading providers CSV:", error);
    throw error;
  }
};

